import { render, staticRenderFns } from "./CountriesStats.vue?vue&type=template&id=064ef311&scoped=true&"
import script from "./CountriesStats.vue?vue&type=script&lang=js&"
export * from "./CountriesStats.vue?vue&type=script&lang=js&"
import style0 from "./CountriesStats.vue?vue&type=style&index=0&id=064ef311&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ef311",
  null
  
)

export default component.exports